import React from 'react';
import cn from 'classnames';
import { Link } from '@/Framework/Router/Next/Link';
import UpgradePlanButton from '@/finsight/ui/common/components/UpgragePlanButton';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';

import styles from '@/finsight/ui/components/bonds/BondsTile/TileHeader/tileHeader.scss';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import tilesStyles from '@/finsight/ui/common/tilesStyles.scss';
import { iconStyles } from '@dealroadshow/uikit/core/components/Icon';
import IconQuestion from '@dealroadshow/uikit/core/components/Icon/IconQuestion';

const TileHeaderFallback = ({ tooltipContent }) => (
  <div className={ styles.headerContent }>
    <div className={ styles.headerTitleTextWithoutTools }>
      <h3 className={ spacesStyles.mn }>B&I</h3>
      <h3 className={ spacesStyles.mn }>BWICS & Inventory</h3>
      {
        <div className={ styles.questionIcon }>
          <Tooltip content={ tooltipContent } containerClassName={ styles.questionIconTooltip }>
            <IconQuestion
              className={ cn(iconStyles.smallIcon, styles.questionFill) }
            />
          </Tooltip>
        </div>
      }
    </div>
    <div className={ tilesStyles.buttonsContainer }>
      <span className={ tilesStyles.learnMoreText }>This module is available on the Professional plan.&nbsp;
        <Link to={ finsightWebUrl.getBondsInventoryABSUrl() } dataTest="learnMoreLink">Learn more</Link>
      </span>
      <UpgradePlanButton />
    </div>
  </div>
);

export default TileHeaderFallback;
